// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"3d1cd30a","239":"bcae551d","240":"21eff3e1","354":"c763fa1d","359":"24415f7b","455":"7b99c8b5","642":"4ab90722","764":"de94066a","879":"05caf95d","968":"5f1f3cee","977":"20607526"}[chunkId] + ".chunk.js";
};